import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiEvent {
    constructor() {

    }

    eventData() {
    }

    eventId() {
    }

    eventSource() {
    }

    eventX() {
    }

    eventY() {
    }

    eventZ() {
    }

    flushEvents() {
    }

    hotKeyEvent() {
    }

    peekEvent() {
    }

    waitEvent() {
    }
}
